import { isNilOrEmpty } from '@rentguru/commons-utils';
import kebabCase from 'lodash/kebabCase';

export const SPACE_NAME_MAX_LENGTH = 60;
const SPACE_SLUG_MAX_LENGTH = 48;

export const slugifySpaceName = (spaceName: string): string => {
  const slug = kebabCase(spaceName);
  return (isNilOrEmpty(slug) ? spaceName.trim().toLowerCase() : slug).slice(0, SPACE_SLUG_MAX_LENGTH);
};

interface SpaceDisplayNameParams {
  spaceName?: string | null;
  companyName?: string | null;
  firstName: string;
  lastName: string;
}

export const getSpaceDisplayName = ({
  spaceName,
  companyName,
  firstName,
  lastName,
}: SpaceDisplayNameParams): string => {
  const trimmedSpaceName = spaceName?.trim();
  if (!isNilOrEmpty(trimmedSpaceName)) {
    return trimmedSpaceName;
  }
  const trimmedCompanyName = companyName?.trim();
  if (!isNilOrEmpty(trimmedCompanyName)) {
    return trimmedCompanyName;
  }
  return `${firstName} ${lastName}`.trim();
};
